import styled from 'styled-components';

import { colors, media } from '../../../../../core';

export const Container = styled.div`
  display: flex;
  width: 284px;
  gap: 10px;
  padding: 9px 15px 10px;
  background-color: ${colors.neutral300};
  border-radius: 4px;

  ${media.xsmall} {
    width: 100%;
  }
`;

export const Title = styled.span`
  font-weight: 800;
  color: ${colors.deepTeal};
  display: block;
  margin-bottom: 3px;
`;

export const Description = styled.span`
  color: ${colors.deepTeal};
  font-size: 14px;
`;
